import { ErrorResource } from "../locales";

export const error: ErrorResource = {
    couldNotSave: "Tallennus ei onnistunut",
    ohNoSomethingWentWrong: "Voi ei! Jokin meni vikaan.",
    refreshAndTryAgain: "Päivitä sivu ja yritä uudelleen.",
    goToLogin: "Siirry sisäänkirjautumiseen",
};
